<ion-content>
  <div class="ion-text-center ion-margin-top">
    <ion-text class="no-data" color="success">
      <ion-icon name="checkmark-circle"></ion-icon>
    </ion-text>
    <ion-text color="dark" class="ion-text-center">
      <h5 class="title">{{ 'custom-alert.Solicitud creada con éxito'  | translate }}</h5>
      <p class="ion-no-margin subtitle">{{ 'custom-alert.Un ejecutivo se pondrá en contacto'  | translate }}</p>
    </ion-text>
  </div>
  <ion-button fill="clear" class="back clickable" (click)="modalCtrl.dismiss()">
    {{ 'custom-alert.Cerrar'  | translate }}
  </ion-button>
</ion-content>